import { Link } from "react-router-dom";

const FEATURES = [
  {
    icon: "ri-refresh-line",
    title: "及时更新",
    desc: "热门作品连载章节同步更新，追更不掉队。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "丰富分类",
    desc: "热血、恋爱、奇幻、悬疑等题材随心筛选。",
  },
  {
    icon: "ri-eye-line",
    title: "舒适阅读",
    desc: "字号与背景自由调节，白天夜晚都护眼。",
  },
  {
    icon: "ri-bookmark-line",
    title: "本地收藏",
    desc: "一键收藏喜欢的故事，随时找回阅读进度。",
  },
];

export default function SiteIntro() {
  return (
    <section className="rounded-xl bg-background-50 border border-background-200 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
            <i className="ri-compass-3-line"></i>
            关于老司机漫画
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            找漫画，就来老司机漫画
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            老司机漫画专注于提供丰富多样的热门漫画连载与精彩章节推荐。我们聚合了热血、恋爱、奇幻、悬疑、科幻、校园、都市、搞笑等多元题材，帮助每一位漫画爱好者快速找到对味的故事，并在轻量舒适的阅读环境中沉浸其中。
          </p>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            无论你是想追最新的连载，还是想重温已经完结的经典，这里都能一站满足。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 mt-6 h-11 px-6 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="p-6 md:p-10 bg-background-100 border-t lg:border-t-0 lg:border-l border-background-200">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {FEATURES.map((f) => (
              <div
                key={f.title}
                className="p-4 rounded-lg bg-background-50 border border-background-200"
              >
                <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 font-heading font-bold text-base text-foreground-950">
                  {f.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}